module.exports = __webpack_public_path__ + "img/base_patrimoine_legende.802f7095.svg";